module.exports = __webpack_public_path__ + "9dd930bc786743fdbb244fbfc333dff5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_icon_specific.png
// module id = 9
// module chunks = 0 1 2 3 4